const soundsData = {
	birdsFlying: require('../assets/audio/birds-flying.mp3'),
	backgroundSounds: [
		require('../assets/audio/birds-1.mp3'),
		require('../assets/audio/birds-2.mp3'),
	],
	pigs: require('../assets/audio/pig-sound.ogg'),
}

module.exports = {soundsData};